/**
 * Read-only summary of multiple custom fields in a single row.
 */
import type { Profile } from "@spork/s4p-server-sdk";
import { View } from "react-native";

import { Text } from "@/components/ui/text";

import { formatReadonlyFieldSummary } from "../lib/formatProfileSummary";

type ReadonlySummaryProfileFieldProps = {
    person: Profile;
    label: string;
    fieldCodes: readonly string[];
};

export function ReadonlySummaryProfileField({
    person,
    label,
    fieldCodes,
}: ReadonlySummaryProfileFieldProps) {
    const summary = formatReadonlyFieldSummary(person, fieldCodes);

    if (!summary) {
        return null;
    }

    return (
        <View className="px-3 py-3">
            <Text variant="caption" className="mb-1 text-muted-foreground">
                {label}
            </Text>
            <Text variant="p" className="text-muted-foreground">
                {summary}
            </Text>
        </View>
    );
}
